import React, { useId } from 'react';
import styled from 'styled-components';

import { Bloc } from '../../routes/project/components/step-drawer';
import { useRichTextEditor } from '@producer/ui-kit';
import { EditorContent } from '@tiptap/react';

interface TextAreaDrawerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

export const TextAreaDrawer: React.FC<TextAreaDrawerProps> = ({ label, value, onChange }) => {
  const key = useId();

  const { editor } = useRichTextEditor({
    key,
    value,
    onBlur: onChange,
  });

  return (
    <Bloc>
      <label>{label}</label>

      <Input editor={editor} />
    </Bloc>
  );
};

const Input = styled(EditorContent)`
  min-height: 6.4rem;
  background-color: transparent;
  outline: none;
  flex: 1;
  width: 100%;
  color: var(--color-grayscale-white);
  font-family: Inter, sans-serif;
  font-size: 1.4rem;
  resize: vertical;
  border: none;

  p {
    font-size: 1.4rem;
  }
`;
